import { createGlobalStyle } from "styled-components";
import {
  lightestColor,
  primaryBackgroundColor,
  primaryColor,
  primaryTextColor,
} from "../styles";

export const Styles = createGlobalStyle`

    @font-face {
        font-family: "Motiva Sans Light";
        src: url("/fonts/Motiva-Sans-Light.ttf") format("truetype");
        font-style: normal;
    }

    @font-face {
        font-family: "Motiva Sans Bold";
        src: url("/fonts/Motiva-Sans-Bold.ttf") format("truetype");
        font-style: normal;
    }

    @font-face {
        font-family: 'seasons';
        src: url(./fonts/seasons.woff2) format('woff2');
        font-weight: normal;
        font-style: normal;
    }

    @font-face {
        font-family: 'seasons';
        src: url(./fonts/seasons-bd.woff2) format('woff2');
        font-weight: bold;
        font-style: normal;
    }

    @font-face {
        font-family: 'quicksand';
        src: url(./fonts/Quicksand-VariableFont_wght.woff2) format('truetype');
        font-style: normal;
    }

    body,
    html,
    a {
        font-family: 'quicksand', 'Motiva Sans Light', sans-serif;
    }


    body {
        margin:0;
        padding:0;
        border: 0;
        outline: 0;
        background: ${lightestColor};
        overflow-x: hidden;
    }

    a:hover {
        color: ${primaryTextColor};
    }

    input,
    textarea {
        border-radius: 4px;
        border: 0;
        background: ${primaryBackgroundColor};
        transition: all 0.3s ease-in-out;  
        outline: none;
        width: 100%;  
        padding: 1rem 1.25rem;

        :focus-within {
            background: none;
            box-shadow: ${primaryColor} 2e186a 0px 0px 0px 1px;
        }
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-family: 'Motiva Sans Bold', serif;
        color: ${primaryTextColor};
        font-size: 56px;
        line-height: 1.18;

        @media only screen and (max-width: 890px) {
          font-size: 47px;
        }
      
        @media only screen and (max-width: 414px) {
          font-size: 32px;
        }
    }

    p {
        color: ${primaryTextColor};
        font-size: 21px;        
        line-height: 1.41;
    }

    h1 {
        font-weight: 600;
    }

    // a {
    //     text-decoration: none;
    //     outline: none;
    //     color: ${primaryColor};

    //     :hover {
    //         color: ${primaryColor};
    //     }
    // }
    
    *:focus {
        outline: none;
    }

    .about-block-image svg {
        text-align: center;
    }

    .ant-drawer-body {
        display: flex;
        flex-direction: column;
        text-align: left;
        padding-top: 1.5rem;
    }

    .ant-drawer-content-wrapper {
        width: 300px !important;
    }

    .welcome-heading {
        @media screen and (max-width: 1024px) {
            padding: 5.5rem 0 0rem;
        }
    }
`;
